import React from "react"

import Board_Manager from "../../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell";


type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {
            itemsWithValue  : number
            sum             : number
            value           : number
        }
        children        : {
            itemsWithValue  : number
            sum             : number
            value           : number
        }
        total           : {
            itemsWithValue  : number
            sum             : number
            value           : number
        }

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldToggle_BoardAggregate"
const debug = false

export default function FieldToggle_BoardAggregate(props: Props) {

    const value = props.calculatedData?.total.sum
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', isValid, value, props.calculatedData)

    const showLabel = isValid && !!props.calculatedData?.total.itemsWithValue
    const valueLabel = showLabel ? '{0}/{1}'.f(value, props.calculatedData?.total.itemsWithValue) : ''

    const classes = Classes("left-aligned flex-no-shrink max-w-130", props.className, {
        'show-on-hover': !showLabel
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
        >
            <div className="flex-row-left-center txt-truncate">
                <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                <div className="ui5-txt-not-important-small txt-truncate">
                    {valueLabel}
                </div>
            </div>
        </Board_AggregateShell>
    )
}
